<div id="user-group-container" data-cy="user-roles-container">
  <mat-progress-spinner *ngIf="!roles" style="margin-left: auto; margin-right: auto; position: relative; top: 50%; transform: translateY(-50%)" diameter="100" mode="indeterminate" data-cy="user-roles-loading-spinner"></mat-progress-spinner>
  <mat-grid-list *ngIf="roles" cols="6" rowHeight="100%" style="height:100%;" data-cy="user-roles-grid">
    <mat-grid-tile colspan="2" data-cy="user-roles-list-tile">
      <mat-card appearance="outlined" style="width:100%; height:100%;" data-cy="user-roles-list-card">
        <span class="configuration-section-title" data-cy="user-roles-list-title">Roles</span>
        <div style="height: calc(100% - 100px)" data-cy="user-roles-table-container">
          <!--<app-tdo-table #rolesTable [tdoTableModel]="tableModel" (actionClick)="onTdoTableItemActionClick($event)" (itemSelected)="onTdoTableItemClick($event)"></app-tdo-table>-->
          <tdo-table #rolesTable [dataSource]="roles" sortActive="RoleName" sortDirection="asc" (rowSelected)="onRowSelected($event)" data-cy="user-roles-table">
            <tdo-table-column displayName="Role" propertyName="RoleName" [isSortable]="true" [rowTemplate]="role" data-cy="user-roles-name-column">
              <ng-template #role let-row>
                <div data-cy="user-roles-name-{{row.index}}">{{row.RoleName}}</div>
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="" propertyName="xauditDeleted" [rowTemplate]="del" data-cy="user-roles-delete-column">
              <ng-template #del let-row>
                <div style="cursor: pointer; color: var(--tdo-secondary); margin-left: auto; margin-right: 0;" [matTooltip]="'Delete ' + row.model.RoleName + '?'" (click)="deleteRole(row.model)" data-cy="user-roles-delete-button-{{row.index}}">
                  <mat-icon>delete</mat-icon>
                </div>
              </ng-template>
            </tdo-table-column>
          </tdo-table>
        </div>
      </mat-card>
    </mat-grid-tile>
    <mat-grid-tile colspan="4" data-cy="user-roles-detail-tile">
      <mat-card appearance="outlined" style="width:100%;height:100%" data-cy="user-roles-detail-card">
        <div style="max-width: 700px;" data-cy="user-roles-detail-container">
          <span class="configuration-section-title" data-cy="user-roles-detail-title">Role Settings</span>
<!--          <app-tdo-configuration-action-bar [saveDisabled]="selectedColorScheme === null" (newClick)="onNew($event)" (saveClick)="onSave($event)"></app-tdo-configuration-action-bar>-->
          <app-tdo-configuration-action-bar (newClick)="onNew($event)" (saveClick)="onSave($event)" data-cy="user-roles-action-bar"></app-tdo-configuration-action-bar>
          <div *ngIf="selectedRole" data-cy="user-roles-form-container">
            <mat-form-field style="width:100%; opacity: 50%;" data-cy="user-roles-id-field">
              <mat-label data-cy="user-roles-id-label">Id:</mat-label>
              <input [value]="selectedRole.RoleId" readonly matInput placeholder="Role Id" (input)="configurationService.setDirty();" data-cy="user-roles-id-input" />
            </mat-form-field>
            <br />
            <mat-form-field style="width:100%" data-cy="user-roles-name-field">
              <mat-label data-cy="user-roles-name-label">Name:</mat-label>
              <input matInput placeholder="Name" [(ngModel)]="selectedRole.RoleName" (appInputFinished)="onInputFinished($event); configurationService.setDirty();" data-cy="user-roles-name-input" />
            </mat-form-field>
            <textarea rows="6" style="width: 100%; outline: unset; overflow-y: auto; resize: none; border: 1px solid #cccccc; border-radius: 6px;"
                      [(ngModel)]="selectedRole.Description" (appInputFinished)="onInputFinished($event); configurationService.setDirty();" data-cy="user-roles-description-textarea"></textarea>
          </div>
          <!--<div *ngIf="!selectedColorScheme" (click)="onNew($event)" style="position: relative; top: 200px; width: 100%; text-align: center; cursor: pointer;">
            Click here, or new to create first item
          </div>
          <br />
          <div class="alert alert-danger" *ngIf="this.errorMessage.length > 0">
            {{errorMessage}}
          </div>-->
        </div>
      </mat-card>
    </mat-grid-tile>
  </mat-grid-list>
</div>

